export default class MeasureResource {
  constructor(client) {
    this.client = client;
  }

  list() {
    return this.client.get("/measures").then((resp) => resp.data);
  }
  find(id) {
    return this.client.get("/measures/" + id).then((resp) => resp.data);
  }
  create(measure) {
    return this.client.post("/measures", measure).then((resp) => resp.data);
  }
  update(measureId, params) {
    return this.client
      .patch("/measures/" + measureId, params)
      .then((resp) => resp.data);
  }
  delete(measureId) {
    return this.client.delete("/measures/" + measureId);
  }
  exportCsv(measureId, distination) {
    return this.client
      .post("/measures/" + measureId + "/csv", { distination })
      .then((resp) => resp);
  }
  getSeries(id) {
    return this.client
      .get("/measures/" + id + "/series")
      .then(({ data }) => data);
  }
  getThreshold(id) {
    return this.client
      .get("/measures/" + id + "/threshold")
      .then(({ data }) => data);
  }
  updateThreshold(id, threshold) {
    return this.client
      .patch("/measures/" + id + "/threshold", threshold)
      .then(({ data }) => data);
  }
  updateGraphConfigs(id, graphConfigs) {
    return this.client.patch("/measures/" + id + "/graph_configs", {
      measure: { graph_configs_attributes: graphConfigs },
    });
  }
}
